import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User dismissed an announcement from a surface',
  name: 'announcement_dismissed',
  params: [
    {
      description: 'Internal announcement name',
      name: 'name',
      required: true,
      type: 'string',
    },
    {
      description: 'Surface where the announcement was dismissed',
      name: 'surface',
      required: true,
      type: 'enum',
      values: ['global', 'assetDetails', 'canvas', 'canvasNullState', 'canvasChatComposer', 'boards', 'plans'],
    },
    {
      description: 'Announcement id',
      name: 'announcement_id',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
